module.exports = __webpack_public_path__ + "img/icon-2.2652e5b9.svg";